/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function pay(params, context) {
    // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/payment.html?spm=a2d5h.23431124.0.0
    var formatInput = function (options) { return ({
        orderInfo: options.payStr,
    }); };
    context === null || context === void 0 ? void 0 : context.WVCall('AliPayModule.payV2', params, {
        formatInput: formatInput,
    });
}

export { pay as default };
